/**************
 Mobile Nav
 ***************/

// desktop mega menu
const header = document.querySelector("#header");
const slider = document.querySelector("#slider");
const headerNavLinks = document.querySelectorAll(".headerNavLink");

function closeMegaMenu() {
    headerNavLinks.forEach(link => link.classList.remove("active"));
}

headerNavLinks.forEach(link => {
    if (!link.querySelector(".headerMegaPanel")) return;

    link.addEventListener("mouseenter", function () {
        closeMegaMenu();
        this.classList.add("active");
    });

    link.addEventListener("focusin", function () {
        closeMegaMenu();
        this.classList.add("active");
    });
});

document.addEventListener("mousemove", function (event) {
    if (!event.target.closest("#header") && !event.target.closest(".headerMegaPanel")) {
        closeMegaMenu();
    }
});

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    if (slider && slider.open) {
        closeNav();
        return;
    }
    positionSliderBelowHeader();
    slider.show();
    document.querySelector("body").classList.add("noScroll");
    document.querySelector("body").classList.add("navOpen");
    document.querySelector("#headerMenu")?.setAttribute("aria-expanded", "true");
}

function positionSliderBelowHeader() {
    if (!header || !slider) return;

    const headerBottom = Math.max(0, Math.ceil(header.getBoundingClientRect().bottom));
    slider.style.setProperty("--header-bottom", `${headerBottom}px`);
}

// dialog close event
if(slider){
    slider.addEventListener("close", async function () {
        document.querySelector("body").classList.remove("noScroll");
        document.querySelector("body").classList.remove("navOpen");
        document.querySelector("#headerMenu")?.setAttribute("aria-expanded", "false");
    });
}

// close nav
async function closeNav() {
    slider.close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

window.addEventListener("resize", function () {
    if (slider.open) {
        positionSliderBelowHeader();
    }
});

// register dialog
dialogPolyfill.registerDialog(slider);
